// FETCH ALL PROPERTIES FROM IRONING_PACKING_DC DETAILS
export const FETCH_IRONING_PACKING_DC_DETAILS_REQUEST_DK = 'FETCH_IRONING_PACKING_DC_DETAILS_REQUEST_DK';
export const FETCH_IRONING_PACKING_DC_DETAILS_SUCCESS_DK = 'FETCH_IRONING_PACKING_DC_DETAILS_SUCCESS_DK';
export const FETCH_IRONING_PACKING_DC_DETAILS_FAILURE_DK = 'FETCH_IRONING_PACKING_DC_DETAILS_FAILURE_DK';

// FETCH ALL PROPERTIES FROM IRONING_PACKING_DC DETAILS
export const FETCH_IRONING_PACKING_DC_DETAILS_PROGRAM_REQUEST_DK = 'FETCH_IRONING_PACKING_DC_DETAILS_PROGRAM_REQUEST_DK';
export const FETCH_IRONING_PACKING_DC_DETAILS_PROGRAM_SUCCESS_DK = 'FETCH_IRONING_PACKING_DC_DETAILS_PROGRAM_SUCCESS_DK';
export const FETCH_IRONING_PACKING_DC_DETAILS_PROGRAM_FAILURE_DK = 'FETCH_IRONING_PACKING_DC_DETAILS_PROGRAM_FAILURE_DK';

export const FETCH_IRONING_PACKING_DC_DETAIL_EDIT_QUANTITY_REQUEST_DK = 'FETCH_IRONING_PACKING_DC_DETAIL_EDIT_QUANTITY_REQUEST_DK';
export const FETCH_IRONING_PACKING_DC_DETAIL_EDIT_QUANTITY_SUCCESS_DK = 'FETCH_IRONING_PACKING_DC_DETAIL_EDIT_QUANTITY_SUCCESS_DK';
export const FETCH_IRONING_PACKING_DC_DETAIL_EDIT_QUANTITY_FAILURE_DK = 'FETCH_IRONING_PACKING_DC_DETAIL_EDIT_QUANTITY_FAILURE_DK';

// FETCH ALL PROPERTIES FROM IRONING_PACKING_DC DETAILS BY ID
export const FETCH_IRONING_PACKING_DC_DETAILS_BY_ID_REQUEST_DK = 'FETCH_IRONING_PACKING_DC_DETAILS_BY_ID_REQUEST_DK';
export const FETCH_IRONING_PACKING_DC_DETAILS_BY_ID_SUCCESS_DK = 'FETCH_IRONING_PACKING_DC_DETAILS_BY_ID_SUCCESS_DK';
export const FETCH_IRONING_PACKING_DC_DETAILS_BY_ID_FAILURE_DK = 'FETCH_IRONING_PACKING_DC_DETAILS_BY_ID_FAILURE_DK';

// CREATE PROPERTIES FOR IRONING_PACKING_DC DETAILS
export const CREATE_IRONING_PACKING_DC_DETAILS_REQUEST_DK = 'CREATE_IRONING_PACKING_DC_DETAILS_REQUEST_DK';
export const CREATE_IRONING_PACKING_DC_DETAILS_SUCCESS_DK = 'CREATE_IRONING_PACKING_DC_DETAILS_SUCCESS_DK';
export const CREATE_IRONING_PACKING_DC_DETAILS_FAILURE_DK = 'CREATE_IRONING_PACKING_DC_DETAILS_FAILURE_DK';

export const CREATE_IRONING_PACKING_DC_DETAIL_EDIT_QTY_MASTER_REQUEST_DK = 'CREATE_IRONING_PACKING_DC_DETAIL_EDIT_QTY_MASTER_REQUEST_DK';
export const CREATE_IRONING_PACKING_DC_DETAIL_EDIT_QTY_MASTER_SUCCESS_DK = 'CREATE_IRONING_PACKING_DC_DETAIL_EDIT_QTY_MASTER_SUCCESS_DK';
export const CREATE_IRONING_PACKING_DC_DETAIL_EDIT_QTY_MASTER_FAILURE_DK = 'CREATE_IRONING_PACKING_DC_DETAIL_EDIT_QTY_MASTER_FAILURE_DK';

//CREATE USER FORM
export const CREATE_USER_FORM_IRONING_PACKING_DC_DETAILS_DK = 'CREATE_USER_FORM_IRONING_PACKING_DC_DETAILS_DK';

export const CREATE_USER_FORM_IRONING_PACKING_DC_EDIT_QTY_DK = 'CREATE_USER_FORM_IRONING_PACKING_DC_EDIT_QTY_DK';

export const RESET_IRONING_PACKING_DC_EDIT_QTY_DK = 'RESET_IRONING_PACKING_DC_EDIT_QTY_DK';

// UPDATE PROPERTIES FOR IRONING_PACKING_DC DETAILS
export const UPDATE_IRONING_PACKING_DC_DETAILS_REQUEST_DK = 'UPDATE_IRONING_PACKING_DC_DETAILS_REQUEST_DK';
export const UPDATE_IRONING_PACKING_DC_DETAILS_SUCCESS_DK = 'UPDATE_IRONING_PACKING_DC_DETAILS_SUCCESS_DK';
export const UPDATE_IRONING_PACKING_DC_DETAILS_FAILURE_DK = 'UPDATE_IRONING_PACKING_DC_DETAILS_FAILURE_DK';

// FETCH SINGLE IRONING_PACKING_DC_DETAILS
export const FETCH_SINGLE_IRONING_PACKING_DC_DETAILS_REQUEST_DK = 'FETCH_SINGLE_IRONING_PACKING_DC_DETAILS_REQUEST_DK';
export const FETCH_SINGLE_IRONING_PACKING_DC_DETAILS_SUCCESS_DK = 'FETCH_SINGLE_IRONING_PACKING_DC_DETAILS_SUCCESS_DK';
export const FETCH_SINGLE_IRONING_PACKING_DC_DETAILS_FAILURE_DK = 'FETCH_SINGLE_IRONING_PACKING_DC_DETAILS_FAILURE_DK';

// DELETE PROPERTIES FOR IRONING_PACKING_DC DETAILS
export const DELETE_IRONING_PACKING_DC_DETAILS_REQUEST_DK = 'DELETE_IRONING_PACKING_DC_DETAILS_REQUEST_DK';
export const DELETE_IRONING_PACKING_DC_DETAILS_SUCCESS_DK = 'DELETE_IRONING_PACKING_DC_DETAILS_SUCCESS_DK';
export const DELETE_IRONING_PACKING_DC_DETAILS_FAILURE_DK = 'DELETE_IRONING_PACKING_DC_DETAILS_FAILURE_DK';

// USERFORM RESET

export const IRONING_PACKING_DC_DETAILS_USERFORM_RESET_DK = 'IRONING_PACKING_DC_DETAILS_USERFORM_RESET_DK';

//DCNO
export const FETCH_IRONING_PACKING_DC_DETAILS_DC_NO_REQUEST_DK_DK = 'FETCH_IRONING_PACKING_DC_DETAILS_DC_NO_REQUEST_DK_DK';
export const FETCH_IRONING_PACKING_DC_DETAILS_DC_NO_SUCCESS_DK_DK = 'FETCH_IRONING_PACKING_DC_DETAILS_DC_NO_SUCCESS_DK_DK';
export const FETCH_IRONING_PACKING_DC_DETAILS_DC_NO_FAILURE_DK_DK = 'FETCH_IRONING_PACKING_DC_DETAILS_DC_NO_FAILURE_DK_DK';

//GRN NO
export const FETCH_GRN_NO_BY_IRONING_PACKING_DC_NO_REQUEST_DK_DK = 'FETCH_GRN_NO_BY_IRONING_PACKING_DC_NO_REQUEST_DK_DK';
export const FETCH_GRN_NO_BY_IRONING_PACKING_DC_NO_SUCCESS_DK_DK = 'FETCH_GRN_NO_BY_IRONING_PACKING_DC_NO_SUCCESS_DK_DK';
export const FETCH_GRN_NO_BY_IRONING_PACKING_DC_NO_FAILURE_DK_DK = 'FETCH_GRN_NO_BY_IRONING_PACKING_DC_NO_FAILURE_DK_DK';

export const IRONING_PACKING_CLOSE_BTN_POST_REQUEST = 'IRONING_PACKING_CLOSE_BTN_POST_REQUEST';
export const IRONING_PACKING_CLOSE_BTN_POST_SUCCESS = 'IRONING_PACKING_CLOSE_BTN_POST_SUCCESS';
export const IRONING_PACKING_CLOSE_BTN_POST_FALIURE = 'IRONING_PACKING_CLOSE_BTN_POST_FALIURE';

export const RESET_IRONING_PACKING_DC_DETAIL_INWARD_NO = 'RESET_IRONING_PACKING_DC_DETAIL_INWARD_NO';

export const IRONING_PACKING_CHECK_ALL_UPDATE_REQUEST = 'IRONING_PACKING_CHECK_ALL_UPDATE_REQUEST';
export const IRONING_PACKING_CHECK_ALL_UPDATE_SUCCESS = 'IRONING_PACKING_CHECK_ALL_UPDATE_SUCCESS';
export const IRONING_PACKING_CHECK_ALL_UPDATE_FALIURE = 'IRONING_PACKING_CHECK_ALL_UPDATE_FALIURE';

export const FETCH_IRONING_PACKING_DC_DETAILS_EDIT_REQUEST_DK = 'FETCH_IRONING_PACKING_DC_DETAILS_EDIT_REQUEST_DK';
export const FETCH_IRONING_PACKING_DC_DETAILS_EDIT_SUCCESS_DK = 'FETCH_IRONING_PACKING_DC_DETAILS_EDIT_SUCCESS_DK';
export const FETCH_IRONING_PACKING_DC_DETAILS_EDIT_FAILURE_DK = 'FETCH_IRONING_PACKING_DC_DETAILS_EDIT_FAILURE_DK';
